import { createAction, props } from "@ngrx/store";
import { Product } from "../../app/shared/interface/home";



export const loadWishlist = createAction (
    '[wishlist] Load wishlist '
);

export const loadWishlistSuccess = createAction(
  '[Wishlist] Load Success',
  props<{ products: Product[] }>()
);



// Add / Remove
export const addWishlistProduct = createAction(
  '[Wishlist] Add Product',
  props<{ productId:string }>()
);
export const addToWishlistSuccess = createAction(
  '[Wishlist] Add Success',
  props<{ productId: string }>()
);

export const removeWishlistProduct = createAction(
  '[Wishlist] Remove Product',
  props<{ productId: string }>()
);
export const removeFromWishlistSuccess = createAction(
  '[Wishlist] Remove Success',
  props<{ productId: string }>()
);

// Failure actions for error handling
export const addWishlistProductFailure = createAction(
  '[Wishlist] Add Failure',
  props<{ productId: string; error?: any }>()
);
export const removeWishlistProductFailure = createAction(
  '[Wishlist] Remove Failure',
  props<{ productId: string; error?: any }>()
);

export const clearWishlist = createAction('[Wishlist] Clear');
 

export const clearWishlistSuccess = createAction(
  '[Wishlist] Clear Wishlist Success'
);

